import React from "react";
import { Upload, Icon, Modal, Button, Row, Col } from "antd";
import { strings, Loader } from "../../../helpers";
import DocImage from "../../../images/doctor.svg";

export default class DoctorPhotoView extends React.Component {
  render() {
    const {
      previewVisible,
      previewImage,
      fileList,
      handleChange,
      handlePreview,
      handleCancel,
      customRequest,
      onRemove,
      uploading,
      doctorObj
    } = this.props;

    return (
      <div className="clearfix">
        <div className="photo-thumbnail-wrapper">
          {fileList.length > 0 ? (
            fileList.map(imageObj => {
              return (
                <React.Fragment>
                  <div className="photo-thumbnail-box">
                    <a
                      href="javascript:;"
                      className="photo-thumbnail for-doctor"
                      style={{ backgroundImage: `url(${imageObj.url})` }}
                    >
                      <div className="photo-thumbnail-overlay">
                        <div className="photo-thumbnail-actions top-50">
                          <div className="actions">
                            <a
                              href="javascript:;"
                              onClick={() => handlePreview(imageObj)}
                            >
                              <Icon type="eye" />
                            </a>
                            <a
                              href="javascript:;"
                              onClick={() => onRemove(imageObj)}
                            >
                              <Icon type="delete" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </React.Fragment>
              );
            })
          ) : (
            <Row type="flex">
              <Col span={24}>
                <div
                  className="picture-wrapper mb-10"
                  style={{
                    backgroundImage: `url(${DocImage})`
                  }}
                />
              </Col>
            </Row>
          )}
        </div>

        <Upload
          showUploadList={false}
          customRequest={customRequest}
          action="//jsonplaceholder.typicode.com/posts/"
          onPreview={handlePreview}
          onChange={handleChange}
          accept=".jpeg, .jpg, .png, .tiff"
          disabled={uploading}
          multiple={false}
          className="doc-img-upload"
        >
          <Button
            disabled={uploading}
            className="img-circular-btn"
            size="small"
            type="primary"
          >
            {!uploading && <Icon type="plus" />}
            {/* {fileList.length ? strings.update : strings.add} */}
          </Button>
        </Upload>
        {uploading && <Loader className="loader-absolute" />}

        {/*  following is the photo thumbnail ui */}
        <Modal visible={previewVisible} footer={null} onCancel={handleCancel}>
          <img alt="example" style={{ width: "100%" }} src={previewImage} />
        </Modal>
      </div>
    );
  }
}
